import ApplicationController from "./application_controller.js";

export default class extends ApplicationController {
  static values = {
    documentName: String,
    imageUrl: String,
  };

  connect() {}

  openImagePanel() {
    console.log(`${this.documentNameValue}`);
    top.jsPanel.ziBase = 9999;
    top.jsPanel.create({
      headerTitle: `${this.documentNameValue}`,
      headerControls: {
        // this functionality doesn't work as image not in iframe
        //			add: {
        //				html: `<i class="fa fa-print" aria-hidden="true"></i>`,
        //				name: 'print',
        //				position: 1,
        //				handler: function(panel, control) { panel.content.querySelector('iframe').contentWindow.print(); }
        //			},
        smallify: "remove",
        maximize: "remove",
        size: "lg",
      },
      theme: "bootstrap-info",
      closeOnEscape: true,
      contentSize: "660px 60%",
      position: { my: "right-top", at: "right-top", autoposition: "left" },
      dragit: { containment: [0] },
      contentOverflow: "auto",
      content: `<img src=" ${this.imageUrlValue}" alt="${this.documentNameValue}"/>`,
    });
  }
}
